import { FaRegCheckCircle } from 'react-icons/fa';
import { MdErrorOutline } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    overflow-y: auto;
    background-color: ${({ theme }) => theme.hotelDetails.background};
  }
`;

export const Detail = styled.div`
  margin-top: 20px;
  padding: 0 16px;
`;

export const SubTitle = styled.h5`
  font-weight: bold;
  color: ${({ theme }) => theme.hotelDetails.subtitleColor};
  padding-bottom: 10px;
  font-size: 22px;
  font-weight: 600;
  padding-top: 5px;
  line-height: 1.09;
`;

export const CardFooterScore = styled.div`
  display: flex; 
  align-items: center; 
  gap: 6px; 
  font-size: 11px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const CardFooterScoreValue = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  background: ${({ theme }) => theme.primaryBackgroundColor};
  color: ${({ theme }) => theme.primaryColor};
  padding: 1px 10px; 
  border-radius: 8px; 
`;

export const CardFooterScoreText = styled.span`
  font-size: 12px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;  
`;

export const Info = styled.h5`
  color: ${({ theme }) => theme.hotelDetails.infoColor};
  font-size: 16px;
  line-height: 1.5;
`;

export const InfoFullAddress = styled.h5`
  color: ${({ theme }) => theme.hotelDetails.infoColor};
  font-size: 12px;
  line-height: 1.5;
`;

export const MapContainer = styled.div`
  height: 265px;
  background-color: ${({ theme }) => theme.hotelDetails.mapContainer};
  margin-top: 25px;
`;

export const PictureContainer = styled.div`
  width: 100%;
  height: 200px;
`;

export const MapBox = styled.div`
  margin-top: 24px;
  height: 264px;
`;

export const MapBottomAddress = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.hotelDetails.bottomAddress};
  background-color: ${({ theme }) => theme.hotelDetails.bookingInfo};
  height: 58px;
  display: block;
`;

export const RoomsHeader = styled.div`
  width: 100%;
  padding: 24px 32px 0 32px;
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.OuterSpace};
  display: block;
  margin-top: 58px;
`;

export const ShareIcon = styled.img`
  flex-shrink: 0;
  font-size: 20px;
  cursor: pointer;
`;

export const Separator = styled.div`
  border-bottom: solid 1px ${({ theme }) => theme.hotelDetails.separator};
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
`;

export const AlertContainer = styled.div`
  position: fixed;
  padding: 16px;
  bottom: 0;
`;

export const PerNightValue = styled.h5`
  font-size: 12px;
  margin-top: 10px;
  font-weight: 600;
  line-height: 1.67;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Value = styled.h5`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  color: ${ColorPalette.HEX.OuterSpace};
`;

export const BestOptionLabel = styled.span`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.BlueViolet};
`;

export const TextIsRefundable = styled.span`
  font-size: 14px;
  line-height: 1.43;
  color: ${ColorPalette.HEX.Apple};
`;

export const TextIsNotRefundable = styled.span`
  margin: 4px 0;
  font-size: 14px;
  color: ${({ theme }) => theme.hotelDetails.nonRefundable};
`;

export const RefundableIcon = styled(FaRegCheckCircle)`
  font-size: 14px;
  margin-right: 3px;
  margin-top: 2px;
  color: ${ColorPalette.HEX.Apple} !important;
`;

export const NonRefundableIcon = styled(MdErrorOutline)`
  vertical-align: middle;
  margin-bottom: 2px;
  font-size: 14px;
  margin-right: 3px;
  color: ${({ theme }) => theme.hotelDetails.red} !important;
`;

export const RoomTitle = styled.h5`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.OuterSpace};
`;
